/* 合法uri */
export function validateURL (textval) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(textval)
}

/* 检测用户名 */
export function validateUserName (str) {
  const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]{2,10}$/
  return reg.test(str)
}

/* 检测密码 */
export function validatePassword (str) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
  return reg.test(str)
}

/* 小写字母 */
export function validateLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/* 邮箱 */
export function validateEmail (str) {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  return reg.test(str)
}

/* 手机：1开头,3、4、5、6、7、8、9第2位,11位数字 */
export function validateMobile (str) {
  const reg = /^1[3456789]\d{9}$/
  return reg.test(str)
}

/* 联系电话(包含港澳台电话) */
export function validatePhone (str) {
  const reg = /(^1[345789]\d{9}$)|(((\d{3,4})|\d{3,4}-|\s)?\d{8})|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
  return reg.test(str)
}

export function validateContact (str) {
  const reg = /(^(\d{3,4}-)?\d{7,8})$|(^1[3456789][0-9]{9}$)/
  return reg.test(str)
}

/* 判断内容是否为身份证 */
export function validateId (str) {
  const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
  return reg.test(str)
}

/* 数字、大小写字母 */
export function validateMix (str) {
  const reg = /(?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z])/
  return reg.test(str)
}

/* 非负整数 */
export function validateIntegerAndZero (str) {
  const reg = /^\d+$/
  return reg.test(str)
}

export function validateInteger (str) {
  const reg = /^\+?[1-9][0-9]*$/
  return reg.test(str)
}

/* 有1-2位小数的正实数 */
export function validateNum (str) {
  const reg = /^[0-9]+(.[0-9]{1,2})?$/
  return reg.test(str)
}

/* 0~100的数字 */
export function validateNum2 (str) {
  const reg = /^\d{0,3}$/
  return reg.test(str)
}

/* 微信号 */
export function validateWechat (str) {
  const reg = /^[a-zA-Z][-_a-zA-Z0-9]{5,19}$/
  return reg.test(str)
}
